import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api } from "../lib/api";

export default function AdminLeads() {
    const [leads, setLeads] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/leads").then(({ data }) => {
            setLeads(data.items || []);
            setTotal(data.total || 0);
        }).catch(() => setLeads([])).finally(() => setLoading(false));
    }, []);

    const exportCSV = async () => {
        try {
            const baseURL = api.defaults.baseURL;
            const token = api.defaults.headers.common["Authorization"];
            const resp = await fetch(`${baseURL}/admin/leads/export`, {
                headers: token ? { Authorization: token } : {},
            });
            const blob = await resp.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "sukaanyas-leads.csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (_e) { /* ignore */ }
    };

    return (
        <div data-testid="admin-leads-page">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
                <div>
                    <span className="label-eyebrow">Smart capture</span>
                    <h1 className="mt-2 font-display text-4xl text-inkDark">Leads</h1>
                    <p className="mt-1 text-inkMuted">Guest emails captured before checkout. {total} {total === 1 ? "lead" : "leads"} total.</p>
                </div>
                <button onClick={exportCSV} className="btn-pill text-sm" data-testid="admin-leads-export-button">
                    <Download size={14} /> Export CSV
                </button>
            </div>

            <div className="mt-8 bg-ivory rounded-2xl border border-inkDark/5 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm" data-testid="admin-leads-table">
                        <thead className="bg-beige text-inkMuted">
                            <tr>
                                <th className="text-left px-4 py-3 font-medium">Email</th>
                                <th className="text-left px-4 py-3 font-medium">Product</th>
                                <th className="text-left px-4 py-3 font-medium">Action</th>
                                <th className="text-left px-4 py-3 font-medium">Captured</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leads.map((l) => (
                                <tr key={l.id} className="border-t border-inkDark/5">
                                    <td className="px-4 py-3 text-inkDark font-medium">{l.email}</td>
                                    <td className="px-4 py-3 text-inkDark">{l.productName || "—"}</td>
                                    <td className="px-4 py-3 capitalize">
                                        <span className={`text-[10px] px-2 py-1 rounded-full ${l.action === 'cart' ? 'bg-skyblue/40 text-inkDark' : 'bg-beige text-inkDark'}`}>{l.action}</span>
                                    </td>
                                    <td className="px-4 py-3 text-inkMuted">{l.createdAt ? new Date(l.createdAt).toLocaleString() : "—"}</td>
                                </tr>
                            ))}
                            {!loading && leads.length === 0 ? (
                                <tr><td colSpan={4} className="px-4 py-10 text-center text-inkMuted">No leads yet.</td></tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
